class MegaMenu extends HTMLElement {
    constructor() {
        super();
        this.dropdownHandle = '';

        this.setHeaderHeight()

        window.addEventListener('scroll', this.toogleMegaMenu.bind(this))

        function _s(o, i, p, l) { void 0 === i && (i = 400), void 0 === l && (l = !1), o.style.overflow = "hidden", l && (o.style.display = "block"); var n, t = window.getComputedStyle(o), s = parseFloat(t.getPropertyValue("height")), a = parseFloat(t.getPropertyValue("padding-top")), r = parseFloat(t.getPropertyValue("padding-bottom")), y = parseFloat(t.getPropertyValue("margin-top")), d = parseFloat(t.getPropertyValue("margin-bottom")), g = s / i, m = a / i, h = r / i, u = y / i, x = d / i; window.requestAnimationFrame(function t(e) { void 0 === n && (n = e); e -= n; l ? (o.style.height = g * e + "px", o.style.paddingTop = m * e + "px", o.style.paddingBottom = h * e + "px", o.style.marginTop = u * e + "px", o.style.marginBottom = x * e + "px") : (o.style.height = s - g * e + "px", o.style.paddingTop = a - m * e + "px", o.style.paddingBottom = r - h * e + "px", o.style.marginTop = y - u * e + "px", o.style.marginBottom = d - x * e + "px"), i <= e ? (o.style.height = "", o.style.paddingTop = "", o.style.paddingBottom = "", o.style.marginTop = "", o.style.marginBottom = "", o.style.overflow = "", l || (o.style.display = "none"), "function" == typeof p && p()) : window.requestAnimationFrame(t) }) } HTMLElement.prototype.slideToggle = function (t, e) { 0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e) }, HTMLElement.prototype.slideUp = function (t, e) { _s(this, t, e) }, HTMLElement.prototype.slideDown = function (t, e) { _s(this, t, e, !0) };

        this.initEventListener()


    }

    initEventListener() {
      
       this.querySelectorAll('.w-mega-menu__link').forEach((item) => {
            item.addEventListener("mouseenter", (elem) => {
                const e = elem;
                setTimeout(
                    function () {
                        this.closeDropdown()
                    }.bind(this),
                    100
                );
            });
        })

        this.querySelectorAll(
            ".w-mega-menu__links-li:not(.w-mega-menu__link)"
        ).forEach((item) => {
            item.addEventListener("mouseenter", (elem) => {
                const e = elem;
                setTimeout(
                    function () {
                        if (item.matches(":hover")) {
                            this.dropdownHandle = item.getAttribute("data-handle");
                            this.querySelectorAll(
                                ".w-mega-menu__links-li:not(.w-mega-menu__link)"
                            ).forEach((dropdown) => {
                                dropdown.classList.remove("actif");
                            });
                            item.classList.add("actif");
                            this.openDropdown(item);
                        }
                    }.bind(this),
                    200
                );
            });
        })


        this.addEventListener('mouseleave', this.closeDropdown.bind(this));
    }



    openDropdown(e) {
        if (!document.body.classList.contains('menu-opened')) {
            this.querySelector('.mega-menu__dropdown').slideDown('100');
        }
        document.body.classList.add('menu-opened');
        this.querySelectorAll('.mega-menu__dropdown-container').forEach((dropdown) => {
            dropdown.classList.remove('mega-menu__dropdown-item-actif');
            if (dropdown.getAttribute('data-handle-dropdown') == this.dropdownHandle) {
                dropdown.classList.add('mega-menu__dropdown-item-actif');
            } else {
                dropdown.classList.remove('mega-menu__dropdown-item-actif');
            }
        });

    }


    closeDropdown(e) {
        document.body.classList.remove('menu-opened');
        this.querySelector('.mega-menu__dropdown').slideUp("100");
        this.querySelectorAll('.w-mega-menu__links-li').forEach((dropdown) => {
            dropdown.classList.remove('actif');
        });
    }

    toogleMegaMenu(e) {

        const menu = document.querySelector('.section-mega-menu')
        if (window.scrollY > 150) {
            this.setHeaderHeight()
            menu.classList.add('mega-menu__scroll')

        }
        else {
            this.setHeaderHeight()
            menu.classList.remove('mega-menu__scroll')

        }

    }

    setHeaderHeight() {

        document.documentElement.style.setProperty(
            "--header-height",
            document.querySelector(".w-mega-menu__navigation").offsetHeight + "px"
        );
    }
}

customElements.define('mega-menu', MegaMenu);


class MenuDrawer extends HTMLElement {
    constructor() {
        super();

        this.dropdownHandle = ''
        this.initEventListener()
        this.setHeaderHeight()
    }

    initEventListener() {
        document.querySelector('.w-mega-menu__burger').addEventListener('click', this.openMenuDrawer.bind(this))

        this.querySelectorAll('.w-mega-menu__links-li[data-handle]:not(.w-mega-menu__link)').forEach((item) => {
            item.addEventListener('click', this.openSubMenu.bind(this))
        })

        this.querySelectorAll('.mega-menu__dropdown-back').forEach((item) => {
            item.addEventListener('click', this.closeDropdown.bind(this))
        })

        window.addEventListener('resize', this.setHeaderHeight.bind(this))
    }


    openSubMenu(e) {

        this.dropdownHandle = e.currentTarget.getAttribute("data-handle")
        document.body.classList.add('menu-mobile-opened');
        if (this.dropdownHandle) {
            this.querySelectorAll('.mega-menu__dropdown-container').forEach((dropdown) => {
                dropdown.classList.remove('mega-menu__dropdown-item-actif');
                if (dropdown.getAttribute('data-handle-dropdown') == this.dropdownHandle) {
                    dropdown.classList.add('mega-menu__dropdown-item-actif');
                } else {
                    dropdown.classList.remove('mega-menu__dropdown-item-actif');
                }
            });
        }
    }


    openMenuDrawer() {
        document.body.classList.remove('menu-mobile-opened');
        document.body.classList.add('menu-mobile');
        if (this.classList.contains('menu-open')) {
            document.body.classList.remove('menu-mobile');
        }
        this.classList.toggle('menu-open')

    }

    closeDropdown(e) {
        document.body.classList.remove('menu-mobile-opened');
        this.querySelectorAll('.w-mega-menu__links-li').forEach((dropdown) => {
            dropdown.classList.remove('actif');
        });

        this.querySelectorAll('.mega-menu__dropdown-container').forEach((dropdown) => {
            dropdown.classList.remove('mega-menu__dropdown-item-actif');
        })
    }

    setHeaderHeight() {

        document.documentElement.style.setProperty(
            "--header-height",
            document.querySelector(".w-mega-menu").offsetHeight + "px"
        );

        document.documentElement.style.setProperty(
            "--vh",
            `${window.innerHeight / 100}px`
        );
    }
}

customElements.define('mega-menu-drawer', MenuDrawer);